var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavigationArrowOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M20.532 1.487a2 2 0 0 0-.284.058c-.201.06-17.349 7.318-17.51 7.412-.18.106-.502.43-.605.607-.185.32-.244.54-.247.912-.004.544.176.959.579 1.33l.187.174 3.122 1.562 3.122 1.562 1.562 3.122 1.562 3.122.173.187c.372.402.785.582 1.331.579.372-.002.592-.062.912-.247.178-.102.501-.425.607-.605.12-.206 7.371-17.36 7.423-17.563.058-.225.064-.604.012-.825-.206-.886-1.06-1.495-1.946-1.387m-8.224 5.578L4.243 10.48c-.048.022.283.195 2.805 1.456 1.573.786 2.923 1.47 3 1.52.179.114.383.317.497.496.049.077.732 1.425 1.517 2.997a222 222 0 0 0 1.437 2.848c.013-.013 6.83-16.126 6.822-16.123-.003 0-3.609 1.527-8.014 3.391",
  clipRule: "evenodd"
})));
export default SvgNavigationArrowOn;